<template>
    <div class="block-preview">
        <div class="block-content" :style="contentStyle" :inert="inert">
            <cms-block-renderer
                :block="previewBlock"
                :editable="false"
                :current-language="currentLanguage"
                :index="0"
            />
        </div>
    </div>
</template>

<script>
import CmsBlockRenderer from "@/components/editor/rendering/blocks/cms-block-renderer.vue";

export default {
    name: `BlockPreview`,
    components: { CmsBlockRenderer },
    props: {
        block: {
            type: Object,
            required: true
        },
        maxHeight: {
            type: Number,
            default: null
        },
        maxWidth: {
            type: Number,
            default: null
        },
        scale: {
            type: Number,
            default: 0.15
        },
        inert: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            contentScale: 1,
            contentWidth: 0,
            contentHeight: 0
        };
    },
    computed: {
        previewBlock() {
            return window.cmsFactory.new(this.block);
        },
        currentLanguage() {
            return this.$store.state.previewLanguage || this.$store.getters.displayLanguage;
        },
        contentStyle() {
            const scalePercent = (1 / this.scale) * 100;
            return {
                transform: `translate(-50%, -50%) scale(${this.scale})`,
                width: `${scalePercent}%`
            };
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
.block-preview {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.block-content {
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 60px;
    overflow: hidden;
}
</style>